<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <slot slot="activator"></slot>
    <v-card>
      <v-card-title class="headline">{{ confirm_text }}</v-card-title>
      <v-card-actions>
        <v-btn color="error" @click="confirm">Yes</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="dialog = false">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'confirm-dialog',
    props: {
      'confirm_text': {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        dialog: false
      }
    },
    methods: {
      open() {
        this.dialog = true
      },
      confirm() {
        this.$emit('yes')
        this.dialog = false
      },
      confirmByPressEnter(e) {
        if (e.key === 'Enter') {
          this.confirm()
        }
      }
    },
    mounted() {
      window.addEventListener('keypress',  (e) => this.confirmByPressEnter(e))
    },
    beforeDestroy() {
      window.removeEventListener('keypress',  (e) => this.confirmByPressEnter(e))
    }
  }
</script>

